import { LEAVE_ACTION_TYPES } from "../../actions/utilities";

const initialState = {
  leaves: [],
  loading: false,
  error: null,
  leaveDetails: null, 
};

const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LEAVE_ACTION_TYPES.CREATE_LEAVE_REQUEST:
    case LEAVE_ACTION_TYPES.GET_ALL_LEAVES_REQUEST:
    case LEAVE_ACTION_TYPES.UPDATE_LEAVE_REQUEST:
    case LEAVE_ACTION_TYPES.DELETE_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
       case LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        leaveDetails: null, 
        error: null,
      };
    case LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        leaveDetails: action.payload, 
      };
    case LEAVE_ACTION_TYPES.GET_LEAVE_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LEAVE_ACTION_TYPES.CREATE_LEAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves: [...state.leaves, action.payload],
      };
    case LEAVE_ACTION_TYPES.CREATE_LEAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LEAVE_ACTION_TYPES.GET_ALL_LEAVES_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves: action.payload.leaves,
        totalPages: action.payload.totalPages,
      };
    case LEAVE_ACTION_TYPES.UPDATE_LEAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves: state.leaves.map((leave) =>
          leave.id === action.payload.id ? action.payload : leave
        ),
      };
    case LEAVE_ACTION_TYPES.DELETE_LEAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        leaves: state.leaves.filter((leave) => leave.id !== action.payload),
      };
    case LEAVE_ACTION_TYPES.GET_ALL_LEAVES_FAILURE:
    case LEAVE_ACTION_TYPES.UPDATE_LEAVE_FAILURE:
    case LEAVE_ACTION_TYPES.DELETE_LEAVE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default leaveReducer;